var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWeatherTemperatureBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 16c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3c0-1.3062.8348-2.4175 2-2.8293V8c0-.5523.4477-1 1-1s1 .4477 1 1v5.1707c1.1652.4118 2 1.5231 2 2.8293z",
    fill: "#24272A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 6v5.101c1.2372 1.2626 2 2.9917 2 4.899 0 3.866-3.134 7-7 7s-7-3.134-7-7c0-1.9073.7628-3.6364 2-4.899V6c0-2.7614 2.2386-5 5-5s5 2.2386 5 5zm-5 15c-2.0503 0-3.8124-1.2341-4.584-3A4.9834 4.9834 0 017 16c0-1.6358.7855-3.0882 2-4.0004V6c0-1.6569 1.3431-3 3-3s3 1.3431 3 3v5.9996c1.2144.9122 2 2.3646 2 4.0004a4.9832 4.9832 0 01-.416 2c-.7716 1.7659-2.5337 3-4.584 3z",
    fill: "#24272A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2c-.5523 0-1-.4477-1-1zM19 8c-.5523 0-1 .4477-1 1s.4477 1 1 1h2c.5523 0 1-.4477 1-1s-.4477-1-1-1h-2zM2 5c0-.5523.4477-1 1-1h2c.5523 0 1 .4477 1 1s-.4477 1-1 1H3c-.5523 0-1-.4477-1-1zM3 8c-.5523 0-1 .4477-1 1s.4477 1 1 1h2c.5523 0 1-.4477 1-1s-.4477-1-1-1H3z",
    fill: "#24272A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherTemperatureBlack);
export default __webpack_public_path__ + "static/media/Icon-Weather-Temperature-Black.9561c74687f32e238adccdc862a159d1.svg";
export { ForwardRef as ReactComponent };